// extracted by mini-css-extract-plugin
export var col = "index-module--col--BuSKM col";
export var col1 = "index-module--col1--iA32k index-module--col--BuSKM col";
export var col2 = "index-module--col2--7ISrW index-module--col--BuSKM col";
export var cols = "index-module--cols--sdo4t flex section";
export var damage = "index-module--damage--Geo5x index-module--fullWidth--jvj2O util-module--fullWidth--iiqEb util-module--brush2--ysE+q util-module--brush--6CByv";
export var damageBody = "index-module--damageBody--Pmw1j flex sectionBody";
export var maxMd = "(max-width: 48em)";